import React from "react";
import  "./initFirebase";

export const FirebaseProvider: React.FC<any> = ({ children }) => {
  return children;
};
